import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Storage from '@tencent/vft-common/Storage';
var key = 'ysf-lxky-unlock';
export default {
  data: function data() {
    return {};
  },
  computed: {
    config: function config() {
      return window.setting.道具配置;
    },
    supportList: function supportList() {
      return this.$store.state.supportList || [];
    },
    unlock: function unlock() {
      return this.$store.state.unlock;
    },
    list: function list() {
      var _this = this;

      var sList = this.supportList;
      return sList.map(function (item) {
        var star = _this.starList.find(function (star) {
          return star.id === item.id;
        });

        return _objectSpread(_objectSpread({}, star), item);
      });
    }
  },
  watch: {
    supportList: function supportList() {
      var _this2 = this;

      var starListConfig = this.config.明星列表;
      this.supportList.forEach(function (star) {
        var starConfig = starListConfig.find(function (config) {
          return "".concat(config.id) === "".concat(star.id);
        });

        if (!starConfig) {
          return;
        }

        if (star.popularity >= _this2.config.电子相册解锁) {
          var _this2$unlock$star$id;

          if (!((_this2$unlock$star$id = _this2.unlock[star.id]) !== null && _this2$unlock$star$id !== void 0 && _this2$unlock$star$id.photo)) {
            _this2.$store.dispatch('unlock', {
              starid: star.id,
              moduleId: starConfig.电子相册,
              key: 'photo'
            });
          }
        }

        if (star.popularity >= _this2.config.独家花絮解锁) {
          var _this2$unlock$star$id2;

          if (!((_this2$unlock$star$id2 = _this2.unlock[star.id]) !== null && _this2$unlock$star$id2 !== void 0 && _this2$unlock$star$id2.movie)) {
            _this2.$store.dispatch('unlock', {
              starid: star.id,
              moduleId: starConfig.独家花絮,
              key: 'movie'
            });
          }
        }
      });
    },
    unlock: function unlock() {
      this.setUnlockInfo();
    }
  },
  methods: {
    getUnlockInfo: function getUnlockInfo() {
      var unlock = Storage.getJSON(key) || {};
      this.$store.commit('setState', {
        state: 'unlock',
        value: unlock
      });
    },
    setUnlockInfo: function setUnlockInfo() {
      Storage.setJSON(key, this.unlock);
    }
  },
  created: function created() {
    this.getUnlockInfo();
  }
};